"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var bind_1 = require("../../bind");
var tiles_1 = require("../../components/tiles");
var star_rating_1 = require("../../components/star_rating");
var sanitized_render_1 = require("../../components/sanitized_render");
var url_helpers_1 = require("../../url_helpers");
var ReviewList = /** @class */ (function (_super) {
    tslib_1.__extends(ReviewList, _super);
    function ReviewList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReviewList.prototype.getBackgroundImageStyle = function (reviewData) {
        if (!reviewData.avatar)
            return null;
        return { backgroundImage: "url(" + url_helpers_1.imageUploadURL(reviewData.avatar) + ")" };
    };
    ReviewList.prototype.renderReview = function (reviewData) {
        return (React.createElement("div", { className: "review-item" },
            React.createElement("div", { className: "review-item__user" },
                React.createElement("div", { className: "review-item__avatar", style: this.getBackgroundImageStyle(reviewData) }),
                reviewData.name),
            React.createElement("div", { className: "review-item__main" },
                React.createElement("h4", { className: "cms-h4 mtb-0" }, reviewData.title),
                React.createElement("div", { className: "mb-half" },
                    React.createElement("div", { className: "d-inline-block mr-half" },
                        React.createElement(star_rating_1.default, { rating: reviewData.rating ? +reviewData.rating / 5 : 1 })),
                    reviewData.verified &&
                        React.createElement("span", { className: "size-90 valign-bottom weight-bold color-orange", "data-review-verified": true }, I18n.t('discovery.cspReviewModule.verifiedPurchase'))),
                React.createElement("p", { className: "review-item__body" }, reviewData.content))));
    };
    ReviewList.prototype.render = function () {
        return (React.createElement("div", { className: "cms-reviews" },
            React.createElement("div", { className: "cms-reviews__inner" },
                this.props.titleHtml &&
                    React.createElement(sanitized_render_1.default, { htmlTag: "div", className: "cms-reviews__title", html: this.props.titleHtml, blacklistedTags: ['a'] }),
                React.createElement(tiles_1.default, { oneWide: true }, this.props.reviews.map(this.renderReview)))));
    };
    tslib_1.__decorate([
        bind_1.default
    ], ReviewList.prototype, "renderReview", null);
    return ReviewList;
}(React.Component));
exports.default = ReviewList;
//# sourceMappingURL=review_list.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/components/review_list.js
// module id = NJnA
// module chunks = 0 2 6 20